"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.Select = function (children, kind) {
    var elements = [];
    react_1.Children.forEach(children, function (child, i) {
        if (!child.type) {
            return;
        }
        if (child.type.displayName === kind) {
            elements.push(child);
        }
        if (child.props.children) {
            var es = exports.Select(child.props.children, kind);
            elements = __spreadArrays(elements, es);
        }
    });
    return elements;
};
